import React, {useState, useContext, useEffect} from 'react';
import { UserRegistrationContext } from "./ShareStates";
import { getUserRegisterSerialNumberQuery, getQueryResult } from "../../commonFunctions/GraphqlFunctions";
import CustomerErrorMessage from "./CustomerErrorMessage";

const SerialNumberFrom = () => {
    const {
        serialNumber1,
        // serialNumber2,
        updateDisplayForm,
        updateSerialNumber1,
        // updateSerialNumber2,
        updatePreviousForm
    } = useContext(UserRegistrationContext);
    const [showFirstSerialNumberExample, setShowFirstSerialNumberExample] = useState("");
    // const [showSecondSerialNumberExample, setShowSecondSerialNumberExample] = useState("");
    const [serialNumber1Value, setSerialNumber1Value] = useState("");
    // const [serialNumber2Value, setSerialNumber2Value] = useState("");
    const [serialNumber1Error, setSerialNumber1Error] = useState("");
    // const [serialNumber2Error, setSerialNumber2Error] = useState("");
    const [displayErrorNotice, setDisplayErrorNotice] = useState("none");
    const [mountReadOnce, setMountReadOnce] = useState("none");
    const [displayErrorNoticeCustomerValue, setDisplayErrorNoticeCustomerValue] = useState("none");
    const [displayErrorNoticeGraphQLValue, setDisplayErrorNoticeGraphQLValue] = useState("none");

    useEffect(() => {
        if (mountReadOnce === "none") {
            setSerialNumber1Value(serialNumber1);
            // setSerialNumber2Value(serialNumber2);
            setMountReadOnce("visited");
        }
    // }, [mountReadOnce, serialNumber1, serialNumber2, setMountReadOnce]);
    }, [mountReadOnce, serialNumber1, setMountReadOnce]);

    const inputChange = (event) => {
        event.preventDefault();
        if (event.target.id === "serial_number_1") {
            setSerialNumber1Value(event.target.value);
            if (serialNumber1Error !== "") {
                setSerialNumber1Error("");
            }
        }
        // if (event.target.id === "serial_number_2") {
        //     setSerialNumber2Value(event.target.value);
        //     if (serialNumber2Error !== "") {
        //         setSerialNumber2Error("");
        //     }
        // }
    }

    const showSerialNumberExample = (event) => {
        event.preventDefault();
        // console.log(event.target.getAttribute("for"));
        if (event.target.getAttribute("for") === "serial_number_1") {
            if (showFirstSerialNumberExample === "show") {
                setShowFirstSerialNumberExample("");
                // setShowSecondSerialNumberExample("");
            }
            else {
                setShowFirstSerialNumberExample("show");
                // setShowSecondSerialNumberExample("");
            }
        }
        // if (event.target.getAttribute("for") === "serial_number_2") {
        //     if (showSecondSerialNumberExample === "show") {
        //         setShowFirstSerialNumberExample("");
        //         setShowSecondSerialNumberExample("");
        //     }
        //     else {
        //         setShowFirstSerialNumberExample("");
        //         setShowSecondSerialNumberExample("show");
        //     }
        // }
    }

    const hideSerialExample = (event) => {
        // console.log(event.target);
        event.preventDefault();
        setShowFirstSerialNumberExample("");
        // setShowSecondSerialNumberExample("");
    }

    const displaySerialNumberMessage = (SerialNumberNumber) => {
        return (
            <ul className={"information " + SerialNumberNumber} onClick={hideSerialExample}>
                <li>
                    <span>Where to find the serial number</span>
                    <img src={"https://cdn.omax.com/web-assets/saml/serial-plates.png"} alt={"serial number example"}></img>
                </li>
                <li>
                    <p>
                        <strong>OMAX Machines:</strong> found on the cantilever support or controller support arm.
                    </p>
                    <p>
                        <strong>MAXIEM Machines:</strong> found on the bridge upright.
                    </p>
                    <p>
                        <strong>Pumps:</strong> found on the support plate.
                    </p>
                    <p>
                        <strong>A-Jet and Tilt-A-Jet:</strong> found at the top of the cutting head on one side. Note that the accessory serial number data plate looks slightly different than the examples shown here.
                    </p>
                    <p>
                        <strong>ProtoMAX:</strong> remove back panel and serial number is located on back of machine.
                    </p>
                </li>
            </ul>
        )
    }

    const getDisplayErrorNotice = (errorType, error) => {
        if (errorType === 'message') {
            console.log(error);
            setDisplayErrorNotice("block");
            setDisplayErrorNoticeCustomerValue("none");
            setDisplayErrorNoticeGraphQLValue("block");
        }
        if (errorType === 'customer') {
            setDisplayErrorNotice("block");
            setDisplayErrorNoticeCustomerValue("block");
            setDisplayErrorNoticeGraphQLValue("none");
        }
        if (errorType === 'none') {
            setDisplayErrorNotice("none");
            setDisplayErrorNoticeCustomerValue("none");
            setDisplayErrorNoticeGraphQLValue("none");
        }
    }

    const nextAction = async (event) =>  {
        // console.log(event.target.id);
        event.preventDefault();
        if (serialNumber1Value.trim() === "") {
            setSerialNumber1Error("First Serial Number is Required");
        }
        // if (serialNumber2Value.trim() === "") {
        //     setSerialNumber2Error("Second Serial Number is Required");
        // }
        if (serialNumber1Value.trim() !== "") {
            let getUserRegisterSerialNumberResult = await getQueryResult(
                getUserRegisterSerialNumberQuery(),
                {"serialNumber1": serialNumber1Value});
            if (getUserRegisterSerialNumberResult !== undefined) {
                // console.log(typeof getUserRegisterSerialNumberResult.data['supportSiteUserRegisterCheckSerialNumber']['message']);
                if (getUserRegisterSerialNumberResult.data['supportSiteUserRegisterCheckSerialNumber']['message'] !== undefined) {
                    let messageOutput = getUserRegisterSerialNumberResult.data['supportSiteUserRegisterCheckSerialNumber']['message'];
                    // console.log(messageOutput);
                    if (messageOutput === "no customer ID found" || messageOutput === "no customer ID not match") {
                        getDisplayErrorNotice("customer", getUserRegisterSerialNumberResult.data['supportSiteUserRegisterCheckSerialNumber']['message']);
                    }
                    else {
                        getDisplayErrorNotice("message", getUserRegisterSerialNumberResult.data['supportSiteUserRegisterCheckSerialNumber']['message']);
                    }
                }
                else {
                    let customerName = getUserRegisterSerialNumberResult.data['supportSiteUserRegisterCheckSerialNumber']['customer']
                    if (customerName === "") {
                        getDisplayErrorNotice("customer", "customer not found");
                    }
                    else {
                        updateSerialNumber1(serialNumber1Value);
                        updatePreviousForm("serialNumberForm");
                        let country = getUserRegisterSerialNumberResult.data['supportSiteUserRegisterCheckSerialNumber']['country'];
                        if (country === "USA") {
                            updateDisplayForm("zipForm");
                        }
                        else {
                            updateDisplayForm("regionForm");
                        }
                    }
                }
            }
            else {
                getDisplayErrorNotice("message", getUserRegisterSerialNumberResult);
            }
        }
        else {
            getDisplayErrorNotice("customer", "serial numbers are the same");
        }
    }

    return (
        <div>
            <React.Fragment>
                <fieldset name={"machineStep"} style={{display: "block"}}>
                    <h1>Tell us about your machine</h1>
                    <div className={"errorNotice"} style={{display: displayErrorNotice}}>
                        <div style={{display: displayErrorNoticeCustomerValue}}>
                            {CustomerErrorMessage()}
                        </div>
                        <div style={{display: displayErrorNoticeGraphQLValue}}>
                            There is error contacting the backend server, please contact administrator.
                        </div>
                    </div>
                    <div className={"groupedFormElements noTopMargin"}>
                        <input type={"text"} name={"serial_number_1"} id={"serial_number_1"} className={"required"}
                               placeholder={"Enter serial number"} value={serialNumber1Value} onChange={inputChange}>
                        </input>
                        <label htmlFor={"serial_number_1"} className={"info icon m-icon-info-circled"} data-info={"firstSNInfo"} onClick={showSerialNumberExample}>
                            {displaySerialNumberMessage(showFirstSerialNumberExample)}
                        </label>
                        <span id={"error_serial_number_1"} className={"error"}>{serialNumber1Error}</span>
                    </div>
                    <div className={"groupedFormElements"}>
                        If you want to create an account before machine(s) have arrived, please contact your administrator(s) or call customer service at 1-800-298-4036
                    </div>
                    <div style={{width: "100%"}}>
                        <div style={{width: "50%", float: "right", paddingLeft: "10px"}}>
                            <button type={"submit"} className={"nextButton btn"} title={"Next"} onClick={nextAction}>
                                <span>Next</span>
                            </button>
                        </div>
                        <div style={{clear: "both"}}></div>
                    </div>
                </fieldset>
            </React.Fragment>
        </div>
    );
}

export default SerialNumberFrom;